export const getModuleDetails = (moduleId, valves = [], sensorValues = []) => ({
  valves: valves.filter(
    ({ wateringModuleId }) => wateringModuleId === moduleId
  ),
  sensorValues: sensorValues.filter(
    ({ wateringModuleId }) => wateringModuleId === moduleId
  ),
})
